import { Button } from '@bambi/component-library/src/components/Button/Button';
import { CloudArrowDownIcon } from '@heroicons/react/24/outline';

import InvoiceController from '../invoices/InvoiceController';
import { PayoutsExportModal } from './modals/PayoutsExportModal';
import { PayoutsScreenFilters } from './PayoutsScreenFilters';
import { PayoutsDataGrid } from './management/PayoutsDataGrid';
import { useModal } from 'src/common/modals/useModal';

export default function PayoutsScreen() {
  const { open: isExportModalOpen, setOpen: setExportModalOpen } = useModal();

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-row justify-between">
        <PayoutsScreenFilters />
        <Button
          onClick={() => setExportModalOpen(true)}
          variant="secondary-outline"
        >
          <CloudArrowDownIcon className="mr-2 w-5" />
          Download
        </Button>
      </div>
      <PayoutsDataGrid />
      <InvoiceController />
      {isExportModalOpen ? (
        <PayoutsExportModal
          open={isExportModalOpen}
          setOpen={setExportModalOpen}
        />
      ) : null}
    </div>
  );
}
